import { isProdEnv } from '@vfde-sails/utils';
import { QueryParams } from '../interface';
import { debugInfo } from './debug';

const getQueryString = (data: QueryParams) => {
    const params = new URLSearchParams();

    for (const [key, value] of Object.entries(data)) {
        value ? params.set(key, value.toString()) : params.delete(key);
    }

    return params.toString() ? `?${params}` : '';
};

/**
 * Construct url with query params
 * @param {URL|string} url URL.
 * @param {QueryParams=} query Query params for the URL.
 * @returns {string} URL string.
 */
export const getUrl = (url: URL | string, query: QueryParams = {}): string => {
    try {
        const urlWithQuery = new URL(url);

        if (!isProdEnv()) {
            urlWithQuery.protocol = location.protocol;
            urlWithQuery.host = location.host;
        }

        urlWithQuery.search = getQueryString(query);

        return urlWithQuery.toString();
    } catch (error){
        debugInfo(error, 'Error while constructing URL');
        return '';
    }
};
